import { render, staticRenderFns } from "./ShowEvaluation.vue?vue&type=template&id=01f21d06&"
import script from "./ShowEvaluation.vue?vue&type=script&lang=js&"
export * from "./ShowEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports